<template>

  <el-dialog title="编辑" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" :label-width="formLabelWidth">
      <el-form-item label="选择商品" prop="product_id">
         <template>
           <!-- <div>
             <el-button icon="el-icon-plus" @click.stop="$parent.openProduct(form.product,false)">选择产品</el-button>
           </div> -->

           <table v-if="form.product_id" border cellspacing="0" class="mt10" >
             <tr>
               <th class="w150">产品名称</th>
               <th class="w150">产品图片</th>
               <th class="w150">产品价格</th>
             </tr>
             <tr>
               <td class="tc">{{form.product.product_name}}</td>
               <td class="tc">{{form.product.product_name}}</td>
               <td class="tc">{{form.product.product_price}}</td>
             </tr>
           </table>
        </template>
      <!--组件样式-->
      </el-form-item>
      <el-form-item label="赠送冻结积分：" prop="release_points">
        <el-input v-model="form.release_points" type="number" :min="0" :max="100" :step="1" placeholder="请输入赠送积分" class="max-w460" >
          <template slot="append" >个</template>
        </el-input>
      </el-form-item>
      <!-- <el-form-item label="直推增加释放：" prop="first_rate">
        <el-input v-model="form.first_rate" type="number" :min="0" :max="100" :step="1" placeholder="请输入赠送积分" class="max-w460" >
          <template slot="append" >个</template>
        </el-input>
      </el-form-item>
      <el-form-item label="间推增加释放：" prop="second_rate">
        <el-input v-model="form.second_rate" type="number" :min="0" :max="100" :step="1" placeholder="请输入赠送积分" class="max-w460" >
          <template slot="append" >个</template>
        </el-input>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import PointsreleaseApi from '@/api/pointsrelease.js';
export default {
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      loading: false,
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: ['open','form'],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open;
      }
    },
  },
  created() {

  },
  methods: {
    /*转JSON字符串*/
    convertJson(list) {
      let obj = {};

      list.forEach(item => {
        if(item.award){
          obj[item.grade_id] = item.award;
        } else {
          obj[item.grade_id] = 0;
        }
      });

      return JSON.stringify(obj);
    },
    /*添加*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = {};
      params = self.form;
      PointsreleaseApi.editProduct(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，修改成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
    },


    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    },

  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/pointsrelease/product/dialog/Edit.vue